import Stomp, { Client } from 'webstomp-client';
import SockJS from 'sockjs-client';
import store from 'cache/store';
import { cacheStompBC } from 'features/socketSlice';
import { cacheUserInfo, login } from 'features/authSlice';
import { UserInfoModel } from 'models/userInfoModel';

interface BAUCUA {
    stompClient: Client | null;
    connect: () => void;
    disconnect: () => void;
    sendMessage: (topic: string, payload: any) => void;
}

    
let isConnecting = false;
let isConnected = false;

const bcSocket: BAUCUA = {
    stompClient: null,

    connect: () => {
        if (isConnected || isConnecting) {
            console.log("🔄 Đã kết nối hoặc đang kết nối, bỏ qua");
            return;
        }
        isConnecting = true;

        const urlBC = process.env.REACT_APP_URL_BC;
        const { tokenBC } = store.getState().auth;
        const url = `${urlBC}/gamemini/ws/baucua?access_token=${tokenBC}`;
        const socket = new SockJS(url);
        const stompClient = Stomp.over(socket);
        bcSocket.stompClient = stompClient;
        stompClient.debug = () => {};

        stompClient.connect({}, () => {
            isConnecting = false;
            isConnected = true;
            console.log("✅ Baucua connected");
            store.dispatch(cacheStompBC(stompClient));
        }, (error) => {
            isConnecting = false;
            isConnected = false;
            console.error("❌ Baucua connect error:", error);
            localStorage.removeItem('token');
            store.dispatch(cacheUserInfo({} as UserInfoModel));
            store.dispatch(login(false));
        });
    },

    disconnect: () => {
        if (bcSocket.stompClient && isConnected) {
            bcSocket.stompClient.disconnect(() => {
                console.log("⛔ Baucua disconnected");
                isConnected = false;
            });
        }
    },

    sendMessage: (topic: string, payload: any) => {
        if (bcSocket.stompClient && isConnected) {
            const { apiToken } = store.getState().auth;
            const header = {
                Authorization: apiToken || '',
            };
            bcSocket.stompClient.send(
                topic,
                JSON.stringify(payload),
                header
            );
        }
    },
};
export default bcSocket;
